import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Breadcrumbs, Button, Card, Input } from '../../../../../components/UI/ComponentsUI';
import ContainerService from '../../../../../services/ContainerService';
import { onValueChange, validateInputsRequired } from '../../../../../utils/handleChangeHooks';
import { translate } from '../../../../../utils/util';

const AreaVirtualInsert = (props) => {
    const [areaVirtual, setAreaVirtual] = useState({});

    const onChange = (event) => {
        onValueChange(event, areaVirtual, setAreaVirtual);
    };

    const onConfirm = () => {
        if (validateInputsRequired()) {
            props.areaInsert(areaVirtual, (response) => {
                if (response) {
                    props.history.go(-1);
                }
            });
        }
    };

    return (
        <div>
            <Breadcrumbs id="areaInsert" title={{ icon: "mdi mdi-view-dashboard-outline", label: translate('container:config:patio.virtual-area') }} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <Card>
                        <div className="row" style={{ marginBottom: '0px' }}>
                            <div className="input-field no-padding col s12">
                                <Input
                                    required
                                    label="Nome Area"
                                    minLength="3"
                                    id="name"
                                    name="name"
                                    type="text"
                                    onChange={onChange}
                                    defaultValue={areaVirtual?.code} />
                            </div>
                            <div className="input-field no-padding col s12">
                                <Input
                                    required
                                    label="Local Físico"
                                    minLength="3"
                                    id="physicalLocation"
                                    name="physicalLocation"
                                    type="text"
                                    onChange={onChange}
                                    defaultValue={areaVirtual?.physicalLocation} />
                            </div>
                        </div>
                        <div className="row">
                            <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                            <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                        </div>
                    </Card>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        areaVirtual: state.containerReducer.areaVirtual,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        areaInsert: (area, callback) => {
            dispatch(ContainerService.insertArea(area, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AreaVirtualInsert)));